<template>
  <div v-show="showHeader">
    <span class="text-2xl font-semibold text-center lex-1 text-dark-75">{{ title }}</span>
    <span v-if="subtitle" class="mt-3 text-base text-center lex-1 text-tx-form-title">{{ subtitle }}</span>
  </div>
</template>

<script setup lang='ts'>
interface IProps {
  title: string
  subtitle?: string
  showHeader?: boolean
}

withDefaults(defineProps<IProps>(), {
  subtitle: '',
  showHeader: false,
})
</script>
